import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog"
import { Button } from "../../ui/button"

interface DeleteQuoteModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  quoteName: string
}

export function DeleteQuoteModal({ isOpen, onClose, onConfirm, quoteName }: DeleteQuoteModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete Quote Request</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the quote request from {quoteName}? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-between sm:justify-between">
          <Button variant="outline" onClick={onClose} className="border-gray-300 text-gray-700">
            CANCEL
          </Button>
          <Button variant="destructive" onClick={onConfirm} className="bg-red-500 hover:bg-red-600 text-white">
            DELETE QUOTE REQUEST
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
